module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Dinner-4d66304d9a969c3f54c3267581d54ebe.svg";